<template>
  <div>
    <v-select
      dense
      outlined
      class="language-select pt-3"
      v-model="form.lang"
      @change="updateLanguage"
      :items="portalLanguages"
      item-text="description"
      item-value="key"
      :label="$t('profile.language')">
    </v-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import amplitude from 'amplitude-js'

export default {
  name: 'LanguageSelect',
  data () {
    return {
      form: {
        lang: 'en'
      },
      portalLanguages: [
        { key: 'de', description: 'Deutsch' },
        { key: 'en', description: 'English' },
        { key: 'es', description: 'Español' },
        { key: 'fr', description: 'Français' },
        { key: 'it', description: 'Italiano' },
        { key: 'nl', description: 'Nederlands' },
        { key: 'pt', description: 'Português' },
        { key: 'uk', description: 'Українська' },
        { key: 'zh', description: '中文' }
      ]
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  watch: {
    language (newVal) {
      this.form.lang = newVal
    }
  },
  created () {
    this.form.lang = this.$i18n.locale
  },
  methods: {
    async updateLanguage (val) {
      const previousLang = this.$i18n.locale
      this.$i18n.locale = val
      amplitude.getInstance().logEvent('Language Changed', { previous_lang: previousLang, new_lang: val })
      await this.$store.dispatch('updateLanguage', val)
      this.$emit('updateLanguage')
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
